<template>
  <div>
    <!-- <Header></Header> -->
    <div class="entry_bg">
      <div class="entry" v-if="!content">
        <Skeleton type='con'></Skeleton>
      </div>
      <div class="entry" v-else>
        <div class="entry-title" v-html="title"></div>
        <div class="entry-content" v-html="content"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import Top from './common/top.vue'
import Skeleton from './common/skeleton.vue'

export default {
  name: 'Article',
  components: {
    Header,
    Footer,
    Top,
    Skeleton
  },
   data () {
    return {
      content: '',
      title: '',
      time: '',
      id: '',
      type: 0,
      blogList:["Dropshipping", "Marketing", "Case Studies", "News"]
    }
  },
  deactivated () {
    this.$destroy()
  },
  created () {
    this.id = this.$route.query.p
    
    this.getData()
  },
  methods: {
    getData() {
      this.$axios.get(`/posts/${this.id}`)
        .then((res)=>{
          if (res.data.success && res.data.post) {
            this.content = res.data.post.post_content.replace(/&nbsp;/g, ' ').replace(/ /g," ")
            // console.log( res.data.post.post_content)
            // console.log( this.content)
            this.time = res.data.post.post_date
            this.title = res.data.post.post_title
            // console.log(this.blogList.indexOf(res.data.post.term_name))
            this.type = this.blogList.indexOf(res.data.post.term_name)==-1 ? 1:0 
          }
        })
    },
  },
  watch: {
	  $route (to, from) { //监听路由是否变化
		  if(to.query.p != from.query.p){
			  this.id = to.query.p;
			  this.getData();//重新加载数据
		  }
    }
  }  
}
</script>

<style>
  .entry_bg {
    background: #f6f7fa;
  }
  .entry{
    width: 1200px;
    margin: 0 auto;
    padding: 70px 50px;
    background: #FFFFFF;
  }
  .entry-title{
    font-size: 40px;
    line-height: 48px;
    font-weight: 300;
    text-transform: none;
    font-family: "Open Sans", sans-serif;
  }
  .entry-meta{
    color: #595959;
    font-size: 16px;
    line-height: 21px;
    margin-top: 7px;
    font-family: "Open Sans", sans-serif;
  }
  .entry-content{
    margin-top: 34px;
  }
  .entry-content h3{
    font-size: 20px;
    margin-bottom: 20px;
    line-height: 24px;
    font-weight: 400;
    text-transform: none;
  }
  .entry-content .wp-block-image{
    margin-bottom: 25px;
  }
  .entry-content .size-large{
    height: auto;
    max-width: 100%;
  }
  figure{
    margin: 0 auto;
    clear: both;
    display: table;
  }
  .entry-content img{
    max-width: 100%;
    height: auto;
  }
  figure figcaption{
    margin: 8px 0 17px;
    display: table-caption;
    caption-side: bottom;
  }
  .entry-content p{
    margin-bottom: 25px;
    font-weight: 400;
    text-transform: none;
    font-size: 17px;
    line-height: 1.5;
    font-family: "Open Sans", sans-serif;
    color: #3a3a3a;
  }
  .entry-content p:last-child{
    margin-bottom: 0;
  }
  .entry-content a, .entry-content a:visited{
    color: #1e73be;
  }
  .entry-content a:hover, .entry-content a:active {
    color: #000000;
  }
  .entry-content ul, .entry-content ol{
    list-style: disc;
  }
  .entry-content > ul{
    margin: 0 0 25px 51px;
  }
  .entry-content ul li{
    font-weight: 400;
    text-transform: none;
    font-size: 17px;
    line-height: 1.5;
    font-family: "Open Sans", sans-serif;
    color: #3a3a3a;
  }
  .entry-content ul li>ul{
    margin-left: 25px;
  }
  .entry-content ul li::marker{
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    text-transform: none;
  }
  .wp-block-buttons {
    margin: 34px 0;
  }
  .wp-block-buttons a {
    color: #FC5322;
    font-size: 18px;
  }
  .wp-block-buttons a:hover, .wp-block-buttons a:focus, .wp-block-buttons a:active {
    color: #FC5322;
  }
  .aligncenter {
    text-align: center;
  }

  @media (max-width: 767px){
    .entry{
      width: 100%;
      padding: 1.05rem .46rem .4rem;
    }
    .entry-content{
      word-break: break-word;
    }
    .entry-title{
      font-size: .6rem;
      line-height: .72rem;
      margin-top: .2rem;
    }
    .entry-meta{
      font-size: .23rem;
      line-height: .3rem;
    }
    .entry-content{
      margin-top: .4rem;
    }
    .entry-content h3{
      font-size: .3rem;
      margin-bottom: .3rem;
      line-height: .36rem;
    }
    .entry-content .wp-block-image{
      margin-bottom: .4rem;
    }
    .entry-content p{
      margin-bottom: .4rem;
      font-size: .24rem;
    }
    .entry-content > ul{
      margin: 0 0 .4rem .5rem;
    }
    .entry-content ul li{
      font-size: .24rem;
    }
    .entry-content ul li>ul{
      margin-left: .4rem;
    }
    .wp-block-buttons {
      margin: .34rem 0;
    }
    .wp-block-buttons a {
      color: #FC5322;
      font-size: .24rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/article.vue